import "howler";
import { GameVars } from "./GameVars";
import { GameManager } from "./GameManager";

// audiosprite -e "mp3,ogg" -o ../../assets/audio/sound *.mp3 -f howler -b 96
// audiosprite -e "mp3,ogg" -o ../../assets/audio/music *.mp3 -f howler -b 96
export class AudioManager {

    public static effects: Howl;
    public static soundtrack: Howl;

    private static loopedKeys: { [type: string]: number[]; };
    private static sountrackKey: string;
    private static soundtrackID: number;
    private static lastSound: string;
    private static lastTimeStamp: number;

    public static init(): void {


        AudioManager.effects.on("unlock", () => {
            setTimeout(() => {
                Howler.ctx.resume();
            }, 700);
        });

        AudioManager.soundtrack.on("unlock", () => {
            setTimeout(() => {
                Howler.ctx.resume();
            }, 700);
        });
       
        window.addEventListener("focus", () => {
            setTimeout(() => {
                Howler.ctx.resume();
            }, 700);
        })

        if (typeof window.GameSnacks !== "undefined") {
            GameVars.gameData.soundMuted = !window.GameSnacks.audio.isEnabled();
            GameVars.gameData.soundtrackMuted = !window.GameSnacks.audio.isEnabled();

            window.GameSnacks.audio.subscribe((isEnabled: boolean) => {
                GameVars.gameData.soundMuted = !isEnabled;
                GameVars.gameData.soundtrackMuted = !isEnabled;
                AudioManager.effects.mute(GameVars.gameData.soundMuted);
                AudioManager.soundtrack.mute(GameVars.gameData.soundtrackMuted);
                GameManager.writeGameData();
            });
        } else {
            GameVars.gameData.soundMuted = true;
            GameVars.gameData.soundtrackMuted = true;
        }

        AudioManager.effects.mute(GameVars.gameData.soundMuted);
        AudioManager.soundtrack.mute(GameVars.gameData.soundtrackMuted);

        AudioManager.loopedKeys = {};

        AudioManager.lastTimeStamp = 0;
        AudioManager.lastSound = "";
    }

    public static toggleSoundState(): void {

        GameVars.gameData.soundMuted = !GameVars.gameData.soundMuted;
        GameManager.writeGameData();
        AudioManager.effects.mute(GameVars.gameData.soundMuted);
    }

    public static toggleSoundtrackState(): void {

        GameVars.gameData.soundtrackMuted = !GameVars.gameData.soundtrackMuted;
        GameManager.writeGameData();
        AudioManager.soundtrack.mute(GameVars.gameData.soundtrackMuted);
    }

    public static muteSound(): void {

        AudioManager.effects.mute(true);
    }

    public static muteSoundtrack(): void {

        AudioManager.soundtrack.mute(true);
    }

    public static unMuteSound(): void {

        AudioManager.effects.mute(false);
    }

    public static unMuteSoundtrack(): void {

        AudioManager.soundtrack.mute(false);
        if (!AudioManager.soundtrack.playing) {
            AudioManager.stopSoundtrack();
            AudioManager.playSoundtrack("soundtrack", .25);
        }
    }

    public static playSound(key: string, loop?: boolean, volume?: number, rate?: number): void {

        if (key === AudioManager.lastSound && Date.now() - AudioManager.lastTimeStamp < 200 && !loop) {
            return;
        }

        // para que no se solapen 2 loops
        if (loop && AudioManager.loopedKeys[key]) {
            return;
        }

        AudioManager.lastSound = key;
        AudioManager.lastTimeStamp = Date.now();

        loop = loop || false;
        volume = volume || 1;
        rate = rate || 1;

        let id = AudioManager.effects.play(key);
        AudioManager.effects.loop(loop, id);
        AudioManager.effects.volume(volume, id);
        AudioManager.effects.rate(rate, id);

        if (loop) {

            if (!AudioManager.loopedKeys[key]) {
                AudioManager.loopedKeys[key] = [];
            }

            AudioManager.loopedKeys[key].push(id);
        }
    }

    public static stopSound(key: string, fadeOut?: boolean): void {

        if (AudioManager.loopedKeys[key]) {

            const id = AudioManager.loopedKeys[key].shift();

            if (fadeOut) {
                AudioManager.effects.fade(1, 0, 2000, id)
            } else {
                AudioManager.effects.stop(id);
            }
        }
    }

    public static playSoundtrack(key: string, volume?: number): void {

        if (AudioManager.sountrackKey === key) {
            return;
        }

        volume = volume || 1;

        if (AudioManager.soundtrackID) {
            AudioManager.soundtrack.stop(AudioManager.soundtrackID);
        }

        AudioManager.sountrackKey = key;
        AudioManager.soundtrackID = AudioManager.soundtrack.play(key);

        AudioManager.soundtrack.loop(true, AudioManager.soundtrackID);

        AudioManager.soundtrack.volume(volume, AudioManager.soundtrackID);
    }

    public static stopSoundtrack(): void {
        AudioManager.soundtrack.stop(AudioManager.soundtrackID);
        AudioManager.sountrackKey = null;
    }

    public static setSoundtrackVolume(volume: number): void {

        AudioManager.soundtrack.volume(volume, AudioManager.soundtrackID);
    }

    public static setSoundtrackRate(rate: number): void {

        AudioManager.soundtrack.rate(rate, AudioManager.soundtrackID);
    }

    public static onBlur(): void {

        if (AudioManager.effects) {
            AudioManager.effects.mute(true);
        }

        if (AudioManager.soundtrack) {
            AudioManager.soundtrack.mute(true);
        }
    }

    public static onFocus(): void {

        if (AudioManager.effects && !GameVars.gameData.soundMuted) {
            AudioManager.effects.mute(false);
        }

        if (AudioManager.soundtrack && !GameVars.gameData.soundtrackMuted) {
            AudioManager.soundtrack.mute(false);
        }
    }
}
